// @flow

import get from 'lodash/get';
import { createReducer } from 'redux-act';

import type { QuotedProduct } from 'src/DomainRenew/components/types';

import type { ResultsState as State, CartProductState } from '../../types';
import {
  setDomainLoading,
  setDomainInfo,
  setDomainPrice,
  setCartProductState,
  resetResults,
} from '../actions';

export const initialState: State = {};

const setDomainLoadingHandler = (
  state: State,
  { fqdn, loading }: { fqdn: string, loading: boolean, ... },
): State => {
  if (get(state[fqdn], 'loading') !== loading) {
    return {
      ...state,
      [fqdn]: {
        ...state[fqdn],
        fqdn,
        loading,
      },
    };
  }

  return state;
};

const setDomainInfoHandler = (
  state: State,
  { fqdn, info }: { fqdn: string, info: mixed, ... },
): State => {
  const durations = get(info, 'durations') || [];
  const renewable = !!(
    !get(info, 'prohibited') &&
    get(info, 'in_renew_period') &&
    // $FlowFixMe T54746
    ('renewable' in info ? info.renewable : true) &&
    durations.length > 0
  );
  const restorable = !!get(info, 'restorable');
  const extraneous = !!get(info, 'extraneous');
  const invalid = !!get(info, 'invalid');
  const availability = get(info, 'availability', 'unknown');
  const transferable = get(info, 'transferable', false);

  const output = {
    ...state,
    [fqdn]: {
      ...state[fqdn],
      fqdn,
      invalid,
      extraneous,
      renewable,
      restorable,
      availability,
      transferable,
      minimalDuration: durations[0] || 1,
      cartProductState: 'none',
    },
  };

  return output;
};

const setDomainPriceHandler = (
  state: State,
  quotedProduct: QuotedProduct,
): State => {
  if (!quotedProduct.name || !state[quotedProduct.name]) {
    return state;
  }

  return {
    ...state,
    [quotedProduct.name]: {
      ...state[quotedProduct.name],
      quotation: quotedProduct,
    },
  };
};

const setCartProductStateHandler = (
  state: State,
  {
    fqdn,
    cartProductState,
  }: { fqdn: string, cartProductState: CartProductState, ... },
): State => {
  if (get(state[fqdn], 'cartProductState') !== cartProductState) {
    return {
      ...state,
      [fqdn]: {
        ...state[fqdn],
        cartProductState,
      },
    };
  }

  return state;
};

const resetResultsHandler = () => initialState;

export default (createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setDomainLoading]: setDomainLoadingHandler,
    // $FlowFixMe[invalid-computed-prop]
    [setDomainInfo]: setDomainInfoHandler,
    // $FlowFixMe[invalid-computed-prop]
    [setDomainPrice]: setDomainPriceHandler,
    // $FlowFixMe[invalid-computed-prop]
    [setCartProductState]: setCartProductStateHandler,
    // $FlowFixMe[invalid-computed-prop]
    [resetResults]: resetResultsHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
